export default "__VITE_ASSET__B$LBCAnn__"